import { Layout, Tooltip } from 'antd';
import { NavLink, Outlet } from 'react-router-dom'
import Logo from './assets/saha-logo.svg';

import PageHeader from './components/Common/PageHeader';
import Sidebar from './Sidebar';
import { Calendar03Icon, GlobalEducationIcon, Home04Icon, QuestionIcon } from 'hugeicons-react';

const { Content } = Layout;

const MainLayout = () => {
    return (
        <Layout className='app-layout'>
            <Sidebar></Sidebar>
            <div className="mobile-menu">
                <Tooltip title="Genel Görünüm">
                    <NavLink to="/" end className="mobile-menu-item" aria-label="Genel Görünüm">
                        <Home04Icon size={38} />
                    </NavLink>
                </Tooltip>
                <Tooltip title="Kurslarım">
                    <NavLink to="/my-course" className="mobile-menu-item" aria-label="Kurslarım">
                        <GlobalEducationIcon size={38} />
                    </NavLink>
                </Tooltip>
                <Tooltip title="Yapay Zekâ Asistanı">
                    <NavLink
                        to="/ai-assistant"
                        className="mobile-menu-item mobile-logo"
                        aria-label="Yapay Zekâ Asistanı"
                    >
                        <img src={Logo} width={"40px"} alt="" />
                    </NavLink>
                </Tooltip>
                <Tooltip title="Takvim">
                    <NavLink to="/reminder" className="mobile-menu-item" aria-label="Takvim">
                        <Calendar03Icon size={38} />
                    </NavLink>
                </Tooltip>
                <Tooltip title="Destek">
                    <NavLink to="/support" className="mobile-menu-item" aria-label="Destek">
                        <QuestionIcon size={38} />
                    </NavLink>
                </Tooltip>
            </div> 
            <Layout className="responsive-margin">
                <PageHeader></PageHeader>
                <Content className='main-content'>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    )
}

export default MainLayout
